import React, { useState, useEffect } from 'react';

export function GalleryModal({ images = [], title = "Billedgalleri" }) {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const openLightbox = (index) => setSelectedIndex(index);
  const closeLightbox = () => setSelectedIndex(null);

  const prevImage = (e) => {
    e?.stopPropagation();
    setSelectedIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextImage = (e) => {
    e?.stopPropagation();
    setSelectedIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedIndex === null) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') prevImage();
      if (e.key === 'ArrowRight') nextImage();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedIndex]);

  if (!images || images.length === 0) return null;

  return (
    <div className="space-y-4">
      {title && (
        <h3 className="text-xl font-bold text-[#0B0E14] tracking-tight">
          {title}
        </h3>
      )}

      {/* Grid view */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {images.map((imgUrl, idx) => (
          <div
            key={idx}
            onClick={() => openLightbox(idx)}
            className="group relative aspect-square rounded-xl overflow-hidden bg-gray-100 border border-gray-200 cursor-pointer shadow-sm hover:shadow-md transition-all"
          >
            <img
              src={imgUrl.includes('assets.auxodev.dk') && !imgUrl.includes('/cdn-cgi/image/') ? imgUrl.replace('https://assets.auxodev.dk/', 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/') : imgUrl}
              alt={`Galleri billede ${idx + 1}`}
              loading="lazy"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-[#0B0E14]/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white">
              <i className="fa-solid fa-magnifying-glass-plus text-2xl" aria-hidden="true"></i>
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox Modal */}
      {selectedIndex !== null && (
        <div 
          className="fixed inset-0 z-50 bg-black/90 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in duration-200"
          onClick={closeLightbox}
        >
          {/* Close button */}
          <button
            type="button"
            onClick={closeLightbox}
            className="absolute top-4 right-4 rounded-xl bg-white/10 p-3 text-white transition-colors hover:bg-white/20 hover:text-[#d97706] z-50"
            aria-label="Luk stor visning"
          >
            <i className="fa-solid fa-xmark text-2xl" aria-hidden="true"></i>
          </button>

          {/* Prev button */}
          {images.length > 1 && (
            <button
              type="button"
              onClick={prevImage}
              className="absolute left-4 rounded-xl bg-white/10 p-3 text-white transition-colors hover:bg-white/20 hover:text-[#d97706] z-50"
              aria-label="Forrige billede"
            >
              <i className="fa-solid fa-chevron-left text-2xl" aria-hidden="true"></i>
            </button>
          )}

          {/* Image */}
          <div className="max-w-5xl max-h-[85vh] relative flex flex-col items-center justify-center">
            <img
              src={images[selectedIndex]}
              alt={`Galleri billede ${selectedIndex + 1}`}
              className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
            <p className="text-white/80 text-xs mt-3 font-semibold tracking-wider uppercase">
              Billede {selectedIndex + 1} af {images.length}
            </p>
          </div>

          {/* Next button */}
          {images.length > 1 && (
            <button
              type="button"
              onClick={nextImage}
              className="absolute right-4 rounded-xl bg-white/10 p-3 text-white transition-colors hover:bg-white/20 hover:text-[#d97706] z-50"
              aria-label="Næste billede"
            >
              <i className="fa-solid fa-chevron-right text-2xl" aria-hidden="true"></i>
            </button>
          )}
        </div>
      )}
    </div>
  );
}
